exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toast-early-warning .before-close-btn .icon-lijichakan{color:#2563eb;font-size:19px!important}", ""]);

// exports
